import { useMutation, useQueryClient } from '@tanstack/react-query';
import { BehApiRoutes, behClient } from '../beh-api';
import { useNotification } from '../../shared/notification/useNotification';

export function useRemoveUser() {
  const queryClient = useQueryClient();
  const { notifyUserFromRequest } = useNotification();

  return useMutation({
    mutationFn: (userId: string) =>
      notifyUserFromRequest(
        () => behClient.delete(BehApiRoutes.removeUser(userId)),
        {
          successMessage: 'Benutzer erfolgreich entfernt',
          errorMessage: 'Benutzer konnte nicht entfernt werden'
        }
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [BehApiRoutes.userWithAuthorizations__(0, 10000)]
      });
    }
  });
}
